import * as React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { createTheme } from '@rtkwlf/ui';
import { ThemeProvider } from 'styled-components';
import { ROUTE_PATH, UUID_REGEX } from '../../../../constants';
import { OnboardingContactAddView } from './AddView';
import { OnboardingContactEditView } from './EditView';

const theme = createTheme(
  {},
  {
    typographyLabelFontSize: '14px',
    typographyLabelTextTransform: 'none',
  },
);

export const OnboardingContactRouteManager = () => {
  return (
    <ThemeProvider theme={theme}>
      <Switch>
        <Route
          exact
          path={ROUTE_PATH.ONBOARDING.CONTACTS.NEW}
          component={OnboardingContactAddView}
        />

        <Route
          exact
          path={`${ROUTE_PATH.ONBOARDING.CONTACTS.EDIT}/:uuid(${UUID_REGEX})`}
          component={OnboardingContactEditView}
        />

        <Redirect to={ROUTE_PATH.ONBOARDING.MAIN} />
      </Switch>
    </ThemeProvider>
  );
};
